/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * AccountIcon - Auto-generated from icon.js
 */
export const AccountIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M13.5149 12.272C14.9222 11.536 15.8817 10.08 15.8817 8.384C15.8817 5.968 13.9147 4 11.5 4C9.08529 4 7.11834 5.968 7.11834 8.384C7.11834 10.08 8.09382 11.552 9.50107 12.272C6.36674 13.072 4 15.664 4 18.656C4 19.408 4.5597 20 5.26333 20H17.7367C18.4403 20 19 19.408 19 18.656C19 15.264 16.4574 12.992 13.5149 12.272ZM8.07783 8.384C8.07783 6.496 9.61301 4.96 11.5 4.96C13.387 4.96 14.9222 6.496 14.9222 8.384C14.9222 10.272 13.387 11.808 11.5 11.808C9.61301 11.808 8.07783 10.272 8.07783 8.384ZM17.7367 19.04H5.26333C5.03945 19.04 4.95949 18.8 4.95949 18.656C4.95949 15.584 7.94989 12.992 11.5 12.992C14.7143 12.992 18.0405 15.12 18.0405 18.656C18.0245 18.8 17.9446 19.04 17.7367 19.04Z" fill="#333333" />
	</svg>
);

export default AccountIcon;
